import React, { useEffect } from 'react';
import { Container, Button, Typography, Backdrop, CircularProgress, Stack} from '@mui/material';
import Header from '../components/layout/Header';
import { useParams } from 'react-router-dom';
import EventDescription from '../components/sections/EventDescription';
import EventTicketPaper from '../components/ui/EventTicketPaper';
import Footer from '../components/layout/Footer';
import { Context } from '../App';

export const InscriptionContext = React.createContext();
const SelectTickets = () => {
    const {isConnected, setCount} = React.useContext(Context);
    const { id } = useParams()
    const [load, setLoad] = React.useState(true);
    const [event, setEvent] = React.useState('');
    const [tickets, setTickets] = React.useState([]);

    async function handleSubmit() {
        if(tickets.reduce((acc, t) => acc + t.count, 0) === 0) {
            alert('Veuillez sélectionner au moins un ticket avant de continuer.');
            return;
        }
        setLoad(true);
        const billet = tickets.map(t => Array(t.count).fill({
            event: id,
            tarif: t.nom,
            price: t.montant
        })).flat();
        
        fetch(`${process.env.REACT_APP_API_URL}/billets/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${isConnected ? localStorage.getItem('token') : localStorage.getItem('anonUserId') || ''}`
            },
            body: JSON.stringify(billet)
        })
        .then(response => {
            const token = response.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if (!response.ok) {
                throw new Error('Failed to create tickets');
            }
            return response.json();
        })
        .then(data => {
            setLoad(false);
            // Redirect to ticket info form
            window.location.href = `/billetterie/${id}/tickets-info`;
        })
        .catch(error => {
            console.error('Error creating tickets:', error);
            setLoad(false);
            alert('Une erreur est survenue lors de la création des tickets. Veuillez réessayer.');
        });
    }

    useEffect(()=>{
        fetch(`${process.env.REACT_APP_API_URL}/public/event/${id}`, { method: 'GET' })
        .then(response => {
            const token = response.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            console.log(response.status)
            return response.json()
        })
        .then(data => {
            setEvent(data);
            setTickets(data.isFree ? 
                [{count:0, nom: 'Gratuit', montant: 0, description: 'Inscription gratuite'}] : 
                data.tarifs.filter(t => t.type !== 'guichet').map(t=>({...t, count:0})) || []);
            setLoad(false);
        })
        .catch(error => console.error('Error fetching event:', error))
        .finally(() => setLoad(false));
    }, [id]);
  
  return (
    <>
        <Header />
        <EventDescription {...{event}} />

        {event.statut==='en cours' &&<Container maxWidth="sm" sx={{ mt: 4, minWidth: { xs: 'auto', sm: '500px' }, px: { xs: 2, sm: 3 } }}>
            <Stack direction='column' spacing={{ xs: 1.5, sm: 2 }}>
                {(tickets.some(t=>t.type==='early'&&t.tickets_restants>0) ? tickets.filter(t=>t.type==='early'&&t.tickets_restants>0) : tickets).map((tarif, index) => (
                    <EventTicketPaper key={index} {...{tarif, setCount:(count)=> setTickets(old=>old.map((t, i)=> i===index ? ({...t, count: count}): t))}} />
                ))}
            </Stack>
            <Typography variant="h6" sx={{ mt: { xs: 1.5, sm: 2 }, fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
                Total: {tickets.reduce((acc, tarif) => acc + tarif.montant*tarif.count, 0)?? 0} €
            </Typography>
            <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary', fontSize: { xs: '0.8rem', sm: '0.875rem' }, lineHeight: { xs: 1.3, sm: 1.43 } }}>
                Sélectionnez le nombre de tickets pour chaque tarif ci-dessus, puis cliquez sur "Ajouter au panier" pour continuer.
            </Typography>
            <Button variant="contained" color="primary" fullWidth sx={{ mt: { xs: 1.5, sm: 2 }, py: { xs: 1.2, sm: 1.5 }, fontSize: { xs: '0.9rem', sm: '0.875rem' } }} onClick={handleSubmit}>
                Ajouter au panier
            </Button>
        </Container>}

        {event.statut==='fin des inscriptions' && <Container maxWidth="sm" sx={{ mt: 4, minWidth: { xs: 'auto', sm: '500px' }, px: { xs: 2, sm: 3 } }}>
            <Typography variant="h4" color='focus' align='center' sx={{ mb: 2 }}>
                Les inscriptions en ligne sont désormais closes pour cet évènement.
            </Typography>
            <Typography variant="body2" align='center' sx={{ color: 'text.secondary' }}>
                Merci de votre intérêt pour cet événement.
            </Typography>
        </Container>}

        {event.statut==='terminé' && <Container maxWidth="sm" sx={{ mt: 4, minWidth: { xs: 'auto', sm: '500px' }, px: { xs: 2, sm: 3 } }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                L'événement est terminé.
            </Typography>
        </Container>}

        {/* <Container maxWidth="sm" sx={{ mt: 4, minWidth:'500px' }}>
            <Stack direction='column' spacing={2}>
                {tickets.map((tarif, index) => (
                    <EventTicketPaper key={index} {...{tarif, setCount:(count)=> setTickets(old=>old.map((t, i)=> i===index ? ({...t, count: count}): t))}} />
                ))}
            </Stack>
            <Typography variant="h6" sx={{ mt: 2 }}>
                Total: {tickets.reduce((acc, tarif) => acc + tarif.montant*tarif.count, 0)?? 0} €
            </Typography>
            <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                Sélectionnez le nombre de tickets pour chaque tarif ci-dessus, puis cliquez sur "Ajouter au panier" pour continuer.
            </Typography>
            <Button variant="contained" color="primary" fullWidth sx={{ mt: 2 }} onClick={handleSubmit}>
                Ajouter au panier
            </Button>
        </Container> */}
        <Footer />

        <Backdrop open={load}><CircularProgress/></Backdrop>
    </>
  );
};

export default SelectTickets;